import { urlHasProtocol as r, isPublicHttpUrl as i } from "../../../../services/url/index.js";
const s = (o) => {
  const t = r(o) ? o : `https://${o}`;
  if (i(t))
    return t;
};
export {
  s as parseToValidUrl
};
